import type { UseTextFitOptions } from './types'

const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }: HTMLDivElement) =>
  scrollWidth > clientWidth || scrollHeight > clientHeight

interface ResizeTextProps {
  element: HTMLDivElement
  parent: HTMLDivElement
}

export const resizeText =
  ({ maxSize = 10 }: UseTextFitOptions) =>
  ({ element, parent }: ResizeTextProps) => {
    const step = 0.1
    let fontSize = step
    let overflow = false

    while (!overflow && fontSize <= maxSize + step) {
      element.style.fontSize = `${fontSize}rem`
      overflow = isOverflown(parent)

      if (!overflow) fontSize += step
    }

    // Revert to last state where no overflow happened
    element.style.fontSize = `${fontSize - step}rem`
  }
